module.exports = __webpack_public_path__ + "img/ELearningButtonMine.e73a4766.png";